import { useDialog } from 'primevue/usedialog';

type RecoDialogOptions = {
  minWidth?: string;
  maxWidth?: string;
  modal?: boolean;
  showHeader?: boolean;
};

const defaultOptions: RecoDialogOptions = {
  minWidth: '30rem',
  maxWidth: '100vw',
  modal: true,
  showHeader: false,
};

export const useRecoDialog = () => {
  const dialog = useDialog();

  const open = (component: any, data: any, options: RecoDialogOptions = defaultOptions) => {
    const opts = { ...defaultOptions, ...options}
    dialog.open(component, {
      data,
      props: {
        style: {
          minWidth: opts.minWidth,
          maxWidth: opts.maxWidth,
        },
        breakpoints: {
          '960px': '75vw',
          '640px': '90vw',
        },
        modal: opts.modal,
        showHeader: opts.showHeader,
        pt: {
          content: {
            style: {
              overflow: 'hidden',
              minHeight: '0',
              display: 'flex',
              padding: 0,
            },
          },
        },
      },
    });
  };

  return {
    open,
  };
};
